import React from 'react'
import "./Footer.css"
function Footer() {
  return (
    <div className='footer'>
        <div className='back-to-top' onClick={()=> window.scrollTo(0, 0)}>Back to top</div>
        <div className='footer-container'>
                <div className='footer-column'>
                    <h3>Get to Know us</h3>
                    <p>Careers</p>
                    <p>Amazon Newsletter</p>
                    <p>About Amazon</p>
                    <p>Sustainability</p>
                    <p>Press Center</p>
                    <p>Investor Relations</p>
                    <p>Amazon Devices</p>
                    <p>Amazon Sciences</p>
                </div>
                <div className='footer-column'>
                    <h3>Get to Know us</h3>
                    <p>Careers</p>
                    <p>Amazon Newsletter</p>
                    <p>About Amazon</p>
                    <p>Sustainability</p>
                    <p>Press Center</p>
                    <p>Investor Relations</p>
                    <p>Amazon Devices</p>
                    <p>Amazon Sciences</p>
                </div>
                <div className='footer-column'>
                    <h3>Get to Know us</h3>
                    <p>Careers</p>
                    <p>Amazon Newsletter</p>
                    <p>About Amazon</p>
                    <p>Sustainability</p>
                    <p>Press Center</p>
                    <p>Investor Relations</p>
                    <p>Amazon Devices</p>
                    <p>Amazon Sciences</p>
                </div>
                <div className='footer-column'>
                    <h3>Get to Know us</h3>
                    <p>Careers</p>
                    <p>Amazon Newsletter</p>
                    <p>About Amazon</p>
                    <p>Sustainability</p>
                    <p>Press Center</p>
                    <p>Investor Relations</p>
                    <p>Amazon Devices</p>
                    <p>Amazon Sciences</p>
                </div>

        </div>




    </div>
  )
}

export default Footer